import type { Props } from "../../../types";
import { classNameParser } from "../../../helpers";

import "./style.css";

export const SummaryBox = (props: Props) => (
  <div className={classNameParser("summary-box--frame", props.className)} style={props.style} id={props?.id}>
    {props.children}
  </div>
);

export const SummaryDivider = () => (
  <div className="summary-box--divider-frame">
    <div className="summary-box--divider-dot" />
  </div>
);
